import { render, staticRenderFns } from "./task.vue?vue&type=template&id=53225474&scoped=true&"
import script from "./task.vue?vue&type=script&lang=js&"
export * from "./task.vue?vue&type=script&lang=js&"
import style0 from "./task.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./task.vue?vue&type=style&index=1&id=53225474&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53225474",
  null
  
)

export default component.exports